module.exports = __webpack_public_path__ + "media/images/icon_popup_skill_sp-97c14982da882c01fb43c60caa10f057.png";